export default __webpack_public_path__ + "static/media/machineSFX.271d6bf9.mp3";